module.exports = __webpack_public_path__ + "img/fire.e61af79c.svg";